function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.16666 1.74996C1.16666 1.42779 1.42782 1.16663 1.74999 1.16663H12.25C12.5722 1.16663 12.8333 1.42779 12.8333 1.74996C12.8333 2.07213 12.5722 2.33329 12.25 2.33329H1.74999C1.42782 2.33329 1.16666 2.07213 1.16666 1.74996ZM6.99999 3.49996C7.1547 3.49996 7.30307 3.56142 7.41247 3.67081L10.9125 7.17081C11.1403 7.39862 11.1403 7.76797 10.9125 7.99577C10.6847 8.22358 10.3153 8.22358 10.0875 7.99577L7.58332 5.49158V12.25C7.58332 12.5721 7.32216 12.8333 6.99999 12.8333C6.67782 12.8333 6.41666 12.5721 6.41666 12.25V5.49158L3.91247 7.99577C3.68466 8.22358 3.31532 8.22358 3.08751 7.99577C2.85971 7.76797 2.85971 7.39862 3.08751 7.17081L6.58751 3.67081C6.69691 3.56142 6.84528 3.49996 6.99999 3.49996Z",
  fill: "white"
});

function SvgSxUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSxUpload);
export default __webpack_public_path__ + "static/media/sx-upload.d7fa8b37.svg";
export { ForwardRef as ReactComponent };